import groundcover from './groundcover-browser';

if (process.env.REACT_APP_STAGE && process.env.REACT_APP_GROUNDCOVER_DSN && process.env.REACT_APP_GROUNDCOVER_API_KEY) {
	groundcover.init({
		apiKey: process.env.REACT_APP_GROUNDCOVER_API_KEY!,
		dsn: `https://${process.env.REACT_APP_GROUNDCOVER_DSN}`,
		cluster: process.env.REACT_APP_GROUNDCOVER_CLUSTER!,
		environment: process.env.REACT_APP_STAGE!,
		appId: 'events-3',
	});
}
